var React = require('react');

function Sparse (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34,8H0V0h34V8z M34,26H0v8h34V26z M34,13H0v8h34V13z"}));
}

Sparse.defaultProps = {"viewBox":"0 0 34 34","fill":"currentColor","strokeWidth":"0","height":"1em","width":"1em"};

module.exports = Sparse;

Sparse.default = Sparse;
